'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var React = require('react');

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefault(React);

var TransitionGroupContext = React__default['default'].createContext(null);
exports['default'] = TransitionGroupContext;